/** Defaults for work-execution forms (F-rows in audit/14-CHECKS-FORMS-LAYOUT-REVIEW.xlsx). */

/** F-253: a passed inspection needs no notes; the record still says what was recorded. Other outcomes keep the notes. */
export const passedInspectionNotes = 'Passed. No issues noted.';
export function inspectionNotesToSave(outcome: string, notes: string): string {
  const trimmed = notes.trim();
  return trimmed || (outcome === 'Passed' ? passedInspectionNotes : '');
}

/** F-206: how often a checklist repeats, as named intervals. The API stores whole days. */
export const repeatChoices: ReadonlyArray<{value: string; label: string; days: number | null}> = [
  {value: 'once', label: 'One visit only', days: null},
  {value: '7', label: 'Every week', days: 7},
  {value: '14', label: 'Every 2 weeks', days: 14},
  {value: '28', label: 'Every 4 weeks', days: 28},
  {value: '91', label: 'Every 13 weeks', days: 91},
  {value: '182', label: 'Every 26 weeks', days: 182},
  {value: '364', label: 'Every 52 weeks', days: 364},
  {value: 'custom', label: 'Other number of days', days: null},
];
export function repeatDaysFor(choice: string, customDays: string): number | null {
  if (choice === 'custom') { const days = Number(customDays); return Number.isInteger(days) && days >= 1 && days <= 3660 ? days : null; }
  return repeatChoices.find(item => item.value === choice)?.days ?? null;
}
/** F-206: the units meter readings are normally taken in; other units can still be typed. */
export const commonMeterUnits = ['kWh', 'm³', 'litres', 'MWh', 'hours', '°C'] as const;

/** F-205: the preset that matches a stored interval, or 'custom' for any other number of days, or '' when none is set. */
export function intervalChoiceFor(days: number | null, forceCustom: boolean): string {
  if (forceCustom) return 'custom';
  if (days === null) return '';
  return repeatChoices.some(item => item.days === days) ? String(days) : 'custom';
}
export const recordedCompetenceBasis = 'Recorded competence requirements apply.';
/** F-205: the competence basis is prefilled when the default (recorded requirements) applies; declaring no requirement still needs a stated basis. */
export function competenceBasisToSave(mode: string, basis: string): string {
  const trimmed = basis.trim();
  return trimmed || (mode === 'Recorded requirements' ? recordedCompetenceBasis : '');
}
/** F-205: a source basis drawn from the chosen checklist and target when none is typed. */
export function sourceBasisToSave(basis: string, checklistTitle: string | undefined, targetLabel: string | undefined): string {
  const trimmed = basis.trim();
  if (trimmed) return trimmed;
  return checklistTitle && targetLabel ? `Routine ${checklistTitle} for ${targetLabel}.` : '';
}

/** F-209: attendance ends when the planned duration has passed. Both values are London wall-clock datetime-local strings. */
export function attendanceEndFor(start: string, durationMinutes: number | null | undefined): string | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(start);
  if (!match || !durationMinutes || durationMinutes <= 0) return null;
  const [year, month, day, hour, minute] = match.slice(1).map(Number) as [number, number, number, number, number];
  const moment = new Date(Date.UTC(year, month - 1, day, hour, minute + durationMinutes));
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${moment.getUTCFullYear()}-${pad(moment.getUTCMonth() + 1)}-${pad(moment.getUTCDate())}T${pad(moment.getUTCHours())}:${pad(moment.getUTCMinutes())}`;
}
